<div class="winnings-scope">

  <!-- Loading -->
  <div *ngIf="isLoading" class="winnings-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading your winnings...</p>
  </div>

  <div class="winnings-hero" *ngIf="!isLoading">
    <p class="winnings-kicker">Your prizes</p>
    <h1 class="winnings-heading">Hi {{ firstName }}</h1>
    <p class="winnings-sub" *ngIf="totalCount > 0">
      You have won the webinar{{ totalCount === 1 ? '' : 's' }} below. Tap a card to view it.
    </p>
    <p class="winnings-sub" *ngIf="totalCount === 0">
      Your free webinar winnings will show up here. Good luck!
    </p>
  </div>

  <!-- Empty -->
  <div *ngIf="webinars.length === 0 && !isLoading && webinarDivDisplay === 'block'" class="winnings-empty">
    <div class="winnings-empty-icon" aria-hidden="true">🏆</div>
    <h3>No winnings yet</h3>
    <p>Grab a seat in a room to start collecting prizes.</p>
  </div>

  <!-- Grid -->
  <div
    *ngIf="!isLoading && webinars.length > 0"
    [style.display]="webinarDivDisplay">

    <div class="winnings-grid" [attr.data-count]="webinars.length">
      <article
        class="winning-card"
        *ngFor="let webinarDetails of webinars; let i = index"
        (click)="OpenWebinar(webinarDetails.webinarId)"
        (keydown.enter)="OpenWebinar(webinarDetails.webinarId)"
        tabindex="0"
        role="link"
        [attr.aria-label]="'View webinar: ' + webinarDetails.name">

        <div class="card-top-bar">
          <span class="winner-tag">
            <span class="winner-icon" aria-hidden="true">🏆</span> Winner
          </span>
          <div class="card-top-badges">
            <span
              class="shipping-status"
              [class.shipping-status--shipped]="isShipped(webinarDetails)"
              [class.shipping-status--pending]="!isShipped(webinarDetails)">
              {{ isShipped(webinarDetails) ? 'Shipped' : 'Pending' }}
            </span>
            <span class="freebie-badge" *ngIf="webinarDetails.isFreeBee">Free</span>
          </div>
        </div>

        <div class="winning-card-media">
          <div class="media-frame">
            <img
              [src]="webinarDetails.imageUrl || 'assets/Images/demo1.png'"
              [alt]="webinarDetails.name"
              onerror="this.src='assets/Images/demo1.png'">
          </div>
          <span class="seat-badge" *ngIf="webinarDetails.seatNumber">
            <span class="seat-label">Seat No</span>
            <span class="seat-value">#{{ webinarDetails.seatNumber }}</span>
          </span>
        </div>

        <div class="winning-card-body" id="webinar_{{i}}">
          <h3 class="winning-card-title">{{ webinarDetails.name }}</h3>
          <p class="winning-card-desc" *ngIf="webinarDetails.description">{{ webinarDetails.description }}</p>

          <div class="winning-meta-grid">
            <div class="meta-item" *ngIf="webinarDetails.orderId" [title]="webinarDetails.orderId">
              <span class="meta-icon" aria-hidden="true">📋</span>
              <div class="meta-text">
                <span class="meta-label">Order</span>
                <span class="meta-value meta-mono">{{ webinarDetails.orderId }}</span>
              </div>
            </div>
            <div class="meta-item" *ngIf="webinarDetails.orderDate">
              <span class="meta-icon" aria-hidden="true">📅</span>
              <div class="meta-text">
                <span class="meta-label">Date</span>
                <span class="meta-value">{{ webinarDetails.orderDate | date: 'MMM dd, yyyy' }}</span>
              </div>
            </div>
            <div class="meta-item">
              <span class="meta-icon" aria-hidden="true">🚚</span>
              <div class="meta-text">
                <span class="meta-label">Shipping</span>
                <span
                  class="meta-value"
                  [class.meta-value--shipped]="isShipped(webinarDetails)"
                  [class.meta-value--pending]="!isShipped(webinarDetails)">
                  {{ isShipped(webinarDetails) ? 'Shipped' : 'Pending' }}
                </span>
              </div>
            </div>
            <div class="meta-item" *ngIf="isShipped(webinarDetails) && webinarDetails.trackingNumber" [title]="webinarDetails.trackingNumber">
              <span class="meta-icon" aria-hidden="true">📦</span>
              <div class="meta-text">
                <span class="meta-label">Tracking</span>
                <span class="meta-value meta-mono">{{ webinarDetails.trackingNumber }}</span>
              </div>
            </div>
            <div class="meta-item" *ngIf="isShipped(webinarDetails) && webinarDetails.carrierName">
              <span class="meta-icon" aria-hidden="true">✈️</span>
              <div class="meta-text">
                <span class="meta-label">Carrier</span>
                <span class="meta-value">{{ webinarDetails.carrierName }}</span>
              </div>
            </div>
            <div class="meta-item" *ngIf="isShipped(webinarDetails) && webinarDetails.shippedOn">
              <span class="meta-icon" aria-hidden="true">✅</span>
              <div class="meta-text">
                <span class="meta-label">Shipped On</span>
                <span class="meta-value">{{ webinarDetails.shippedOn | date: 'MMM dd, yyyy' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="winning-card-footer">
          View Webinar
        </div>
      </article>
    </div>
  </div>

  <div class="casino-pager" *ngIf="totalCount > 0 && webinarDivDisplay === 'block' && !isLoading">
    <mat-paginator
      class="casino-paginator winnings-paginator"
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      [disabled]="isLoading"
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>

</div>
